import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/page_icons/home.svg'
import _imports_1 from '../../assets/page_icons/modules.svg'
import _imports_2 from '../../assets/page_icons/exercise.svg'
import _imports_3 from '../../assets/page_icons/calendar.svg'
import _imports_4 from '../../assets/page_icons/messages.svg'


const _withScopeId = n => (_pushScopeId("data-v-c0b49bda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "navigation-bar" }
const _hoisted_2 = { class: "row navigation-bar-row" }
const _hoisted_3 = { class: "menu-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-icon",
  alt: "home",
  src: _imports_0
}, null, -1))
const _hoisted_5 = { class: "menu-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-icon",
  alt: "modules",
  src: _imports_1
}, null, -1))
const _hoisted_7 = { class: "menu-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-icon",
  alt: "exercises",
  src: _imports_2
}, null, -1))
const _hoisted_9 = { class: "menu-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-icon",
  alt: "calendar",
  src: _imports_3
}, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-icon",
  alt: "messages",
  src: _imports_4
}, null, -1))
const _hoisted_13 = { class: "icon-number-unread-messages" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "small_headline",
          to: "/home"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("PAGE.HOME")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "small_headline",
          to: "/modules"
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("PAGE.MODULES")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          class: "small_headline",
          to: "/exercises"
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("PAGE.EXERCISES")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          class: "small_headline",
          to: "/agenda"
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("PAGE.AGENDA")), 1)
          ]),
          _: 1
        })
      ]),
      (_ctx.portalMessages == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_router_link, {
              class: "small_headline",
              to: "/messages"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("PAGE.MESSAGES")) + " ", 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getUnreadMessages), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}